// extracted by mini-css-extract-plugin
module.exports = {"content":"Description_content__1-LuO","columns":"Description_columns__2Nd-2","submitBtn":"Description_submitBtn__VXP27"};